<template>
  <span>
    <h3 class='__PLACEHOLDER_total__today'>{{ label }}</h3>
    <zm-tooltip v-if="tip" :content="tip" placement="top">
      <zm-button data-testid="checkout-button-403" type="link" class="zm-icon-info-outline" style="vertical-align: baseline !important" />
    </zm-tooltip>
  </span>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  props: {
    showTodayTotalLabel: Boolean
  },
  computed: {
    ...mapGetters([
      'isInrCitEligible',
    ]),
    label() {
      if (this.$context.is.delta) return this.$t('billing.order_summary.todays_total');
      if (this.$context.is.pro2biz || this.isInrCitEligible) return this.$t('billing.order_summary.todays_total');
      if (this.showTodayTotalLabel) return this.$t('billing.order_summary.todays_total');
      return this.$t('billing.order_summary.total');
    },
    tip() {
      if (this.$context.is.pro2biz) {
        return this.$t('billing.order_summary.todays_total_tip_upgrade');
      }
      return '';
    },
  },
};
</script>
